import { call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../../helpers/request';
import { API } from './constants';
import { usersActions as actions } from '.';
import type { Response, UsersAction } from './types';

export function* fetchUsersGenerator({ payload }: UsersAction) {
  try {
    const response: Response = yield call(request, API.GET_USERS, payload, true);

    if (response?.success) {
      const data = response.data;

      const users = data?.users ? data.users : [];
      const total = data?.total ? data.total : users.length;

      yield put(actions.fetchUsersSucceeded({ users, total }));
    } else {
      yield put(actions.fetchUsersFailed({ message: response?.message || 'Failed to load users.' }));
    }
  } catch (err: any) {
    yield put(actions.fetchUsersFailed({ message: err?.message || 'Failed to load users.' }));
  }
}

export function* usersSaga() {
  yield takeLatest(actions.fetchUsersRequested.type, fetchUsersGenerator);
}

export default usersSaga;

